<template>
  <div id="help-login-detail" class="help">
    <call />
    <!-- header -->
    <top-bar title="ヘルプ" backUrl="/help/login"/>
    <!-- main -->
    <main>
      <footer-app page="top" :loading="loading"></footer-app>
      <section>
        <div class="l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__body">
            <div class="l-check-cart l-check-cart__head pb-50">
              <div class="l-check-cart__title text-left">アカウント連携</div>
              <div class="help-card mb-51">
                <div class="l-check-cart__title text-left">LINEアカウントでログイン</div>
                <p class="l-check-cart__title text-left">1.「LINEアカウントでログイン」ボタンをタップ</p>
                <p>「LINEアカウントでログイン」ボタンをタップします。</p>
                <img class="help-m-b-40 border" src="/assets/images/help/help-login-line-1.png" alt="" />
                <p class="l-check-cart__title text-left">2. 許可するボタンをタップする</p>
                <p>下部の許可するボタンをタップします。</p>
                <img class="help-m-b-40" src="/assets/images/help/help-login-line-2.png" alt="" />
                <p class="l-check-cart__title text-left">3. 確認ボタンをタップする</p>
                <p>下部の確認ボタンをタップするとログインします。</p>
                <img src="/assets/images/help/help-login-line-3.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <button-back />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import TopBar from "../components/TopBar.vue";
import Footer from "../components/Footer.vue";
import ButtonBack from "../components/ButtonBack.vue";

export default Vue.extend({
  name: "HelpLoginDetail",
  components: {
    TopBar,
    FooterApp: Footer,
    ButtonBack,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>